import { useRef, useState } from 'react'
import { useDataContext } from 'context/data-context'
import { Controls, Range, Time, VolumeWrapper } from './styled'
import { formattedTime } from './utils'

export const Player = () => {
  const { strings } = useDataContext()
  const video = useRef<HTMLVideoElement>(null)
  const [volume, setVolume] = useState(0)
  const [progress, setProgress] = useState(0)
  const [totalTime, setTotalTime] = useState(0)
  const [isPlaying, setPlaying] = useState(false)

  const handlePlay = () => {
    video.current?.play()
  }

  const handlePause = () => {
    video.current?.pause()
  }

  const handleProgress = () => {
    setProgress(video.current?.currentTime ?? 0)
  }

  const handleLoadMetadata = () => {
    setTotalTime(video.current?.duration ?? 0)
    setVolume((video.current?.volume ?? 0) * 100)
  }

  return (
    <>
      <video
        onTimeUpdate={handleProgress}
        onLoadedMetadata={handleLoadMetadata}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onEnded={() => setPlaying(false)}
        onVolumeChange={() => {
          setVolume((video.current?.volume ?? 0) * 100)
        }}
        ref={video}
        width="897"
        height="480"
        playsInline
        autoPlay
      >
        <source src={strings.video_url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <Controls>
        {!isPlaying ? (
          <button onClick={handlePlay}>
            <svg
              version="1.1"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M405.2,232.9L126.8,67.2c-3.4-2-6.9-3.2-10.9-3.2c-10.9,0-19.8,9-19.8,20H96v344h0.1c0,11,8.9,20,19.8,20  c4.1,0,7.5-1.4,11.2-3.4l278.1-165.5c6.6-5.5,10.8-13.8,10.8-23.1C416,246.7,411.8,238.5,405.2,232.9z"
                fill="currentColor"
              />
            </svg>
          </button>
        ) : (
          <button onClick={handlePause}>
            <svg
              version="1.1"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="currentColor">
                <rect height="320" width="79" x="128" y="96" />
                <rect height="320" width="79" x="305" y="96" />
              </g>
            </svg>
          </button>
        )}
        <Time>{formattedTime(Math.round(progress))}</Time>
        <Range
          data-progress
          min="0"
          max={totalTime}
          value={Math.round(progress)}
          onChange={(evt) => {
            if (video.current) {
              video.current.currentTime = evt.target.valueAsNumber
            }
          }}
        />
        <Time>{formattedTime(Math.round(totalTime))}</Time>

        <VolumeWrapper>
          <button
            data-volume-button
            onClick={() => {
              if (video.current) {
                video.current.volume = volume > 0 ? 0 : 1
              }
            }}
          >
            <svg
              version="1.1"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="currentColor">
                <polygon points="270,407.7 270,104.4 175.3,192 71,192 71,320 175.3,320" />
                {volume > 25 && (
                  <path d="M326.3,355.6c20.5-27.8,32.8-62.3,32.8-99.6c0-37.4-12.3-71.8-32.8-99.6l-20.4,15.3c17.4,23.6,27.8,52.7,27.8,84.3 c0,31.6-10.4,60.7-27.8,84.3L326.3,355.6z" />
                )}
                {volume > 75 && (
                  <path d="M392.8,401.6c30-40.7,48-91,48-145.6s-18-104.9-48-145.6l-20.4,15.3c26.9,36.4,43,81.4,43,130.3c0,48.9-16.1,93.8-43,130.3 L392.8,401.6z" />
                )}
              </g>
            </svg>
          </button>
          <div>
            <Range
              data-volume
              min="0"
              max="100"
              value={Math.round(volume)}
              onChange={(evt) => {
                if (video.current) {
                  video.current.volume = evt.target.valueAsNumber / 100
                }
              }}
            />
          </div>
        </VolumeWrapper>
      </Controls>
    </>
  )
}
